import { z } from 'zod';
import { WorkbenchRecordTarget } from './workbench-record.js';
const sha = z.string().regex(/^[a-f0-9]{64}$/);
export const WorkbenchProposalHistoryRequest = WorkbenchRecordTarget.safeExtend({
    proposal_id: z.uuid().transform(s => s.toLowerCase()), limit: z.coerce.number().int().min(1).max(50).default(20),
    cursor: z.string().min(1).max(1024).optional(),
});
export const WorkbenchProposalRevision = z.object({
    id: z.uuid(), proposal_id: z.uuid(), version: z.number().int().positive(), kind: z.enum(['working', 'issued']),
    created_at: z.iso.datetime({ offset: true }), content: z.record(z.string(), z.json()),
    work_id: z.uuid().nullable(), assessment_revision_id: z.uuid().nullable(), assessment_content_hash: sha.nullable(),
    content_sha256: sha, revision_sha256: sha,
    /** Working copies contain inputs, not a historical current-price projection. */
    pricing_state: z.enum(['issued_snapshot', 'working_inputs_only', 'unavailable']),
}).strict();
export const WorkbenchProposalHistoryPage = z.object({
    contract: z.literal('aiw.workbench.proposal-history/1'), actor_id: z.uuid(), test_set_id: z.uuid().nullable(),
    target: WorkbenchRecordTarget, record_key: z.string().min(1),
    proposal: z.object({ id: z.uuid(), version: z.number().int().positive(), published_version: z.number().int().positive().nullable(),
        updated_at: z.iso.datetime({ offset: true }), content_sha256: sha }).strict(),
    snapshot_sha256: sha, observed_at: z.iso.datetime({ offset: true }), encoding: z.literal('canonical-json-v1'),
    page: z.object({ offset: z.number().int().nonnegative(), limit: z.number().int().min(1).max(50), total: z.number().int().min(0).max(2000),
        has_more: z.boolean(), next_cursor: z.string().nullable() }).strict(),
    revisions: z.array(WorkbenchProposalRevision).max(50),
}).strict();
//# sourceMappingURL=workbench-proposal-history.js.map